import { render, staticRenderFns } from "./CourseApprovalView.vue?vue&type=template&id=63fd99f8&"
import script from "./CourseApprovalView.vue?vue&type=script&lang=ts&"
export * from "./CourseApprovalView.vue?vue&type=script&lang=ts&"
import style0 from "./CourseApprovalView.vue?vue&type=style&index=0&id=63fd99f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports